<template>
    <v-form :name="props.searchProps.formName"
            @keyup.enter="autoSearch = true">
        <Tabs value="0"
              scrollable>

            <TabList class="mb-4">
                <Tab value="0">{{ __('Basic data') }}</Tab>
            </TabList>

            <TabPanels>
                <TabPanel value="0">
                    <div class="grid">
                        <FormMultiselect fieldName="user_id"
                                         label="User"
                                         size="8"
                                         :isFocus="true"
                                         :options="select?.users"
                                         v-model:field="search.user_id" />

                        <FormMultiselect fieldName="status_id"
                                         label="Status"
                                         size="4"
                                         :options="select?.statuses"
                                         v-model:field="search.status_id" />
                    </div>
                    <div class="grid">
                        <FormMultiselect fieldName="dcttype_id"
                                         label="Alert type"
                                         size="4"
                                         :options="select?.dct_alert_types"
                                         v-model:field="search.dcttype_id" />

                        <FormInputText fieldName="source_table"
                                       label="Source table"
                                       size="4"
                                       v-model:field="search.source_table" />

                        <FormCalendar fieldName="show_alert_date_from"
                                      label="Show alert date from"
                                      size="2"
                                      showTime
                                      hourFormat="24"
                                      dateFormat="yy-mm-dd HH:MM"
                                      v-model:field="search.show_alert_date_from" />

                        <FormCalendar fieldName="show_alert_date_to"
                                      label="Show alert date to"
                                      size="2"
                                      showTime
                                      hourFormat="24"
                                      dateFormat="yy-mm-dd HH:MM"
                                      v-model:field="search.show_alert_date_to" />
                    </div>
                </TabPanel>
            </TabPanels>
        </Tabs>

        <div class="grid">
            <SearchButtons :searchProps="searchProps"
                           :search="search"
                           v-model:autoSearch="autoSearch" />
        </div>
    </v-form>
</template>

<script setup>
import { ref } from "vue";
import Tabs from 'primevue/tabs';
import TabList from 'primevue/tablist';
import Tab from 'primevue/tab';
import TabPanels from 'primevue/tabpanels';
import TabPanel from 'primevue/tabpanel';

import FormInputText from '@crud/FormInputText.vue'
import FormMultiselect from '@crud/FormMultiselect.vue'
import FormCalendar from '@crud/FormCalendar.vue'
import SearchButtons from '@crud/SearchButtons.vue'
import { prepareSearch } from '@pages/Helper/crud_utils.js'
import { __ } from '@helper/utils.js'

// -----------------------------------------------------

const props = defineProps({
    searchProps: Object,
})
const autoSearch = ref(false)

let search = ref({})

const options = ["statuses", "users", "dct_alert_types"];
const select = ref(null);

prepareSearch(search, props, options, select)

</script>

<style lang="scss" scoped></style>
